export function formatReportMoney(value) {
  const num = parseFloat(value);
  if (Number.isNaN(num)) return '₹0.00';
  return num.toLocaleString('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
